import { Fragment, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Home
import Inicio from './views/home/Inicio';

// Login
import Login from './views/auth/Login';

// Register
import Register from './views/auth/Register';

// Terminos
import Terminos from './views/home/Terminos';

// Privacidad
import Privacidad from './views/home/Privacidad';

// Dashboard
import Dashboard from './views/dashboard/Dashboard';

// Configuración
import Perfil from './views/configuracion/perfil/Perfil';

// Membresias
import Membresias from './views/membresias/Membresias';

// Paquetes
import Paquetes from './views/paquetes/Paquetes';

// Citas
import Citas from './views/citas/Citas';

// Redux
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

function App() {
	let token = false;
	
	if (localStorage.token) {
		token = true;
		setAuthToken(localStorage.token);
	}

	useEffect(() => {
		store.dispatch(loadUser());
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout>
						<Alert></Alert>

						<Routes>
							{/* Home */}
							<Route exact path="/" element={<ValidateSession isToken={token}><Inicio /></ValidateSession>}/>

							{/* Login */}
							<Route exact path="/login" element={<ValidateSession isToken={token}><Login /></ValidateSession>}/>

							{/* Register */}
							<Route exact path="/register" element={<ValidateSession isToken={token}><Register /></ValidateSession>}/>

							{/* Terminos */}
							<Route exact path="/terminos" element={<ValidateSession isToken={token}><Terminos /></ValidateSession>}/>

							{/* Privacidad */}
							<Route exact path="/privacidad" element={<ValidateSession isToken={token}><Privacidad /></ValidateSession>}/>

							{/* Dashboard */}
							<Route path="/dashboard" element={<PrivateRoute routePermission=''><Dashboard /></PrivateRoute>}/>

							{/* Configuración */}
							<Route path="/configuracion/perfil" element={<PrivateRoute routePermission='configuracion.perfil.ver'><Perfil /></PrivateRoute>}/>

							{/* Membresias */}
							<Route path="/membresias" element={<PrivateRoute routePermission='membresias.ver'><Membresias /></PrivateRoute>}/>

							{/* Paquetes */}
							<Route path="/paquetes" element={<PrivateRoute routePermission='paquetes.ver'><Paquetes /></PrivateRoute>}/>

							{/* Citas */}
							<Route path="/citas" element={<PrivateRoute routePermission='citas.ver'><Citas /></PrivateRoute>}/>

							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</Layout>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;